import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusExpansionPanelContent], [expansionPanelContent], campus-expansion-panel-content',
})
export class ExpansionPanelContentDirective {}
